<template>
    <div class="search-bar">
        <div class="d-flex align-items-center">
            <label class="mr-sm-2 mb-0">Pencarian</label>
            <form class="form-inline d-flex flex-wrap">
                <div class="form-group mb-0">
                    <input type="text" style="min-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                        placeholder="nama grader..." data-lpignore="true">
                </div>
                <div class="form-group mb-0">
                    <date-picker v-model="searchDate" range type="date" placeholder="Tanggal" :editable="false" format="DD-MM-YYYY"></date-picker>
                </div>
                <div class="input-group">
                    <multiselect class="w-auto flex-grow-1" v-model="searchGudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="input-group">
                    <multiselect class="w-auto flex-grow-1" v-model="searchUser" :options="userOptions" :placeholder="'Pilih grader'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectUser = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="form-group mb-0 mr-1">
                    <multiselect v-model="searchStatus" :options="statusOptions" :placeholder="'Pilih status'" :searchable="true"
                        label="value" track-by="name" :show-labels="false"></multiselect>
                </div>
                <div class="form-group mb-0">
                    <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                    <button class="btn btn-light" @click.prevent="resetSearch">Reset</button>
                </div>
            </form>
        </div>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>

        <b-modal v-model="selectUser" size="lg" :hide-header="true" :hide-footer="true">
            <user-selector :team="'GRADER'" :selected="userOptions" @selected="userSelected" @cancel="selectUser = false"></user-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import GudangSelector from '../gudangs/Selector';
import UserSelector from '../users/Selector';

export default {
    components: {
        Multiselect,
        DatePicker,
        GudangSelector,
        UserSelector,
    },

    data() {
        return {
            selectGudang: false,
            searchGudang: null,
            gudangOptions: [],
            selectUser: false,
            searchUser: null,
            userOptions: [],
            searchText: '',
            searchDate: '',
            searchStatus: '',
            statusOptions: [
                {
                    'name': 'terbayar',
                    'value': 'Terbayar',
                },
                {
                    'name': 'pending',
                    'value': 'Pending',
                },
            ],
        }
    },

    methods: {
        doSearch() {
            let self = this,
                data = {
                    searchText: self.searchText,
                    searchDate: self.searchDate[0] && self.searchDate[1] ? self.searchDateFormat : null,
                    searchGudangId: self.searchGudang ? self.searchGudang.id : '',
                    searchGraderId: self.searchUser ? self.searchUser.id : '',
                    searchStatus: self.searchStatus ? self.searchStatus.name : '',
                };
            self.$emit('search-set', data);
        },

        resetSearch() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudang = null;
            this.searchUser = null;
            this.searchStatus = '';
            this.$emit('search-reset');
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.searchGudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },

        userSelected(user) {
            let self = this;

            self.userOptions.push(user);
            self.searchUser = Object.assign({}, user);
            self.selectUser = false;
        },
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
